<template>
  <div>
    <ag-grid-vue
      :style="tableStyle"
      class="ag-theme-balham ag_table"
      :class="withBorder ? 'ag-border' : ''"
      id="ag-theme-balham"
      :rowData="realRowData"
      :columnDefs="realL"
      :modules="modules"
      :gridOptions="gridOptions"
      :rowSelection="rowSelection"
      domLayout="normal"
      :suppressRowClickSelection="suppressRowClickSelection"
      :processCellForClipboard="processCellForClipboard"
      :icons="icons"
      :autoGroupColumnDef="autoGroupColumnDef"
      :detailCellRenderer="detailCellRenderer"
      :detailCellRendererParams="detailCellRendererParams"
      :groupDefaultExpanded="groupDefaultExpanded"
      :frameworkComponents="frameworkComponents"
      :detailRowHeight="detailRowHeight"
      :masterDetail="masterDetail"
      :excelStyles="excelStyles"
      @sort-changed="onSortChanged"
      @first-data-rendered="onFirstDataRendered"
    ></ag-grid-vue>
  </div>
</template>
<script>
import {AllModules} from "@ag-grid-enterprise/all-modules";
import {AgGridVue} from "@ag-grid-community/vue";
import Operation from "./Operation";
import IPUView from "./IPUView";
import ColorStatus from "./renderer/ColorStatus";

import CompanyTem from "@/components/templates/agGrid/CompanyTem";
import {mapGetters} from "vuex";

import BiddingAmount from "@/components/templates/investor/exchange/receivables/BiddingAmount";
import BiddingAmountHeader from "@/components/templates/investor/exchange/receivables/BiddingAmountHeader";
import PremiumAmount from "@/components/templates/investor/exchange/revolving/PremiumAmount";
import BiddingBuyButton from "@/components/templates/investor/exchange/receivables/BiddingBuyButton";
import BiddingBuyButtonHeader from "@/components/templates/investor/exchange/receivables/BiddingBuyButtonHeader";
import TCISwitch from "@/components/templates/investor/exchange/receivables/TCISwitch";
import TCISwitchHeader from "@/components/templates/investor/exchange/receivables/TCISwitchHeader";

import PriceInput from "@/components/templates/seller/sell/PriceInput";
import TimePicker from "@/components/templates/seller/sell/TimePicker";
import DurrationSelect from "@/components/templates/seller/sell/DurrationSelect";
import RetentionSwitch from "@/components/templates/investor/exchange/receivables/RetentionSwitch";

import ProgressStatus from "@/components/templates/seller/payments/ProgressStatus";
import PaymentTableOperation from "@/components/templates/seller/payments/PaymentTableOperation";
import GeneralShortenedDisplay from "@/components/templates/agGrid/renderer/GeneralShortenedDisplay";
import TimeLeftCountdown from "@/components/templates/agGrid/renderer/TimeLeftCountdown";
import EnumAsText from "@/components/templates/agGrid/renderer/EnumAsText";
import EnumAsIcon from "@/components/templates/agGrid/renderer/EnumAsIcon";
import BooleanAsIcon from "@/components/templates/agGrid/renderer/BooleanAsIcon";

import BankAccountsTableOperation from "@/components/templates/bankAccount/BankAccountsTableOperation.vue";
import InvoiceOperationRender from "@/components/templates/invoices/InvoiceOperationRender.vue";
import ItemDetail from "./ItemDetail";
import SellTableOperation from "@/components/templates/seller/sell/SellTableOperation";
import DebtorOverviewTableOperation from "@/components/templates/seller/debtorManagement/DebtorOverviewTableOperation";
import SellCurrentTableOperation from "@/components/templates/seller/sell/SellCurrentTableOperation.vue";
import ApplyValue from "@/components/templates/agGrid/renderer/ApplyValue";
import InvestorReceivablePaymentsProgressStatus
	from "@/components/templates/investor/payments/receivables/InvestorReceivablePaymentsProgressStatus";
import AllInvestmentsReceivablesTableOperation
	from "@/components/templates/investor/allInvestments/receivables/AllInvestmentsReceivablesTableOperation";
import AllInvestmentsReceivablesTableCollectionOperation
  from "@/components/templates/investor/allInvestments/receivables/AllInvestmentsReceivablesTableCollectionOperation";
import AllInvestmentsRevolvingPutOptionsTableOperation
	from "@/components/templates/investor/allInvestments/revolving/AllInvestmentsRevolvingPutOptionsTableOperation";
import AllReceivablesTableOperation from "@/components/templates/seller/receivables/AllReceivablesTableOperation";
import AllReceivablesStateRenderer from "@/components/templates/seller/receivables/AllReceivablesStateRenderer";
import AssignmentDetailsRenderer from "@/components/templates/seller/receivables/AssignmentDetailsRenderer";
import DebtorConfirmBtn from "@/components/templates/debtor/DebtorConfirmBtn";
import FileLink from "@/components/templates/agGrid/renderer/FileLink";
import MultiFileLink from "@/components/templates/agGrid/renderer/MultiFileLink";
import CustomRatingTableOperation from "@/components/templates/investor/customRating/CustomRatingTableOperation";
import OverdueRenderer from "@/components/templates/agGrid/renderer/OverdueRenderer";
import CustomHeader from "@/components/templates/agGrid/header/CustomHeader";
import CustomGroupHeader from "@/components/templates/agGrid/header/CustomGroupHeader";
import ApiKeysTableOperation from "@/views/user/profile/apiKeys/ApiKeysTableOperation";
import DebtorContactTableOperation from "src/components/templates/seller/debtorManagement/DebtorContactTableOperation";
import IntervalRenderer from "src/components/templates/agGrid/renderer/IntervalRenderer";
import CofaceDraRenderer from "@/components/templates/agGrid/renderer/CofaceDraRenderer";
import RevolvingPutOptionTableOperation from "@/components/templates/seller/putOption/RevolvingPutOptionTableOperation";
import RevolvingPutOptionReferenceRenderer
	from "@/components/templates/agGrid/renderer/RevolvingPutOptionReferenceRenderer";
import RevolvingPutOptionSoldReceivablesPaymentStatusRenderer
	from "@/components/templates/modal/revolvingPutOption/RevolvingPutOptionSoldReceivablesPaymentStatusRenderer";
import InvestorPaymentsRevolvingPutOptionsTableOperation
	from "@/components/templates/investor/payments/revolving/InvestorPaymentsRevolvingPutOptionsTableOperation";
import RevolvingPutOptionOffersTableOperation
	from "@/components/templates/seller/putOption/RevolvingPutOptionOffersTableOperation";
import RevolvingPutOptionContractOverviewTableOperation
	from "@/components/templates/seller/putOption/RevolvingPutOptionContractOverviewTableOperation";
import RevolvingPutOptionPremiumPaymentsStatusRenderer
	from "@/components/templates/modal/revolvingPutOption/RevolvingPutOptionPremiumPaymentsStatusRenderer";
import AllInvestmentsRevolvingPutOptionsAssignmentConfirmationsTableOperation
	from "@/components/templates/investor/allInvestments/revolving/AllInvestmentsRevolvingPutOptionsAssignmentConfirmationsTableOperation";
import ReceivableInvestorNoteIcon from "@/components/templates/agGrid/ReceivableInvestorNoteIcon";
import RetentionSwitchHeader from "@/components/templates/investor/exchange/receivables/RetentionSwitchHeader";
import TCIPremium from "@/components/templates/investor/exchange/receivables/TCIPremium";

// trackpay
import TrackAction from "@/components/templates/trackPay/TrackAction";
import CustomerName from "@/components/templates/trackPay/CustomerName";
import ShipmentProgressStatus from "@/components/templates/trackPay/ShipmentProgressStatus";
import TransferredStatus from "@/components/templates/trackPay/debtor/TransferredStatus";
import ContractStatusScheduled from "@/components/templates/trackPay/ContractStatusScheduled";
import DebtorContractAction from "@/components/templates/trackPay/debtor/DebtorContractAction";
import TrackStatus from "@/components/templates/trackPay/TrackStatus";
import TrackDeviceMark from "@/components/templates/trackPay/TrackDeviceMark";

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CustomHeader,
    // eslint-disable-next-line vue/no-unused-components
    CustomGroupHeader,
    // eslint-disable-next-line vue/no-unused-components
	  InvestorReceivablePaymentsProgressStatus,
    // eslint-disable-next-line vue/no-unused-components
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    Operation,
    // eslint-disable-next-line vue/no-unused-components
    ColorStatus,
    // eslint-disable-next-line vue/no-unused-components
    TCISwitchHeader,
    // eslint-disable-next-line vue/no-unused-components
    TCISwitch,
	  // eslint-disable-next-line vue/no-unused-components
	  TCIPremium,
	  // eslint-disable-next-line vue/no-unused-components
	  BiddingAmountHeader,
    // eslint-disable-next-line vue/no-unused-components
    BiddingAmount,
	  // eslint-disable-next-line vue/no-unused-components
	  PremiumAmount,
    // eslint-disable-next-line vue/no-unused-components
    BiddingBuyButton,
    // eslint-disable-next-line vue/no-unused-components
    BiddingBuyButtonHeader,
    // eslint-disable-next-line vue/no-unused-components
    CompanyTem,
    // eslint-disable-next-line vue/no-unused-components
    IntervalRenderer,
    // eslint-disable-next-line vue/no-unused-components
	  CofaceDraRenderer,
	  // eslint-disable-next-line vue/no-unused-components
	  RevolvingPutOptionReferenceRenderer,
    // eslint-disable-next-line vue/no-unused-components
    IPUView, // eslint-disable-next-line vue/no-unused-components
    PriceInput,
    // eslint-disable-next-line vue/no-unused-components
    TimePicker,
    // eslint-disable-next-line vue/no-unused-components
    DurrationSelect,
    // eslint-disable-next-line vue/no-unused-components
    RetentionSwitch,
	  // eslint-disable-next-line vue/no-unused-components
	  RetentionSwitchHeader,
    // eslint-disable-next-line vue/no-unused-components
    ProgressStatus,
    // eslint-disable-next-line vue/no-unused-components
    PaymentTableOperation,
    // eslint-disable-next-line vue/no-unused-components
    BankAccountsTableOperation,
    // eslint-disable-next-line vue/no-unused-components
    InvoiceOperationRender,
    // eslint-disable-next-line vue/no-unused-components
    GeneralShortenedDisplay,
    // eslint-disable-next-line vue/no-unused-components
    TimeLeftCountdown,
    // eslint-disable-next-line vue/no-unused-components
    EnumAsText,
    // eslint-disable-next-line vue/no-unused-components
    EnumAsIcon,
    // eslint-disable-next-line vue/no-unused-components
    BooleanAsIcon,
    // eslint-disable-next-line vue/no-unused-components
    ApplyValue,
    // eslint-disable-next-line vue/no-unused-components
    ItemDetail,
    // eslint-disable-next-line vue/no-unused-components
    ReceivableInvestorNoteIcon,
    // eslint-disable-next-line vue/no-unused-components
    SellTableOperation,
    // eslint-disable-next-line vue/no-unused-components
    DebtorOverviewTableOperation,
    // eslint-disable-next-line vue/no-unused-components
    DebtorContactTableOperation,
    // eslint-disable-next-line vue/no-unused-components
    SellCurrentTableOperation,
    // eslint-disable-next-line vue/no-unused-components
    AllInvestmentsReceivablesTableOperation,
	  // eslint-disable-next-line vue/no-unused-components
	  AllInvestmentsReceivablesTableCollectionOperation,
	  // eslint-disable-next-line vue/no-unused-components
	  InvestorPaymentsRevolvingPutOptionsTableOperation,
	  // eslint-disable-next-line vue/no-unused-components
	  AllInvestmentsRevolvingPutOptionsTableOperation,
	  // eslint-disable-next-line vue/no-unused-components
	  RevolvingPutOptionSoldReceivablesPaymentStatusRenderer,
    // eslint-disable-next-line vue/no-unused-components
    AssignmentDetailsRenderer,
    // eslint-disable-next-line vue/no-unused-components
    AllReceivablesTableOperation,
    // eslint-disable-next-line vue/no-unused-components
    AllReceivablesStateRenderer,
    // eslint-disable-next-line vue/no-unused-components
    DebtorConfirmBtn,
    // eslint-disable-next-line vue/no-unused-components
    FileLink,
	  // eslint-disable-next-line vue/no-unused-components
	  MultiFileLink,
    // eslint-disable-next-line vue/no-unused-components
    CustomRatingTableOperation,
    // eslint-disable-next-line vue/no-unused-components
    OverdueRenderer,
    // eslint-disable-next-line vue/no-unused-components
    ApiKeysTableOperation,
  	// eslint-disable-next-line vue/no-unused-components
	RevolvingPutOptionTableOperation,
	  // eslint-disable-next-line vue/no-unused-components
	  RevolvingPutOptionOffersTableOperation,
	  // eslint-disable-next-line vue/no-unused-components
	  RevolvingPutOptionContractOverviewTableOperation,
	  // eslint-disable-next-line vue/no-unused-components
	  RevolvingPutOptionPremiumPaymentsStatusRenderer,
	  // eslint-disable-next-line vue/no-unused-components
    AllInvestmentsRevolvingPutOptionsAssignmentConfirmationsTableOperation,
    // eslint-disable-next-line vue/no-unused-components
    TrackAction,
    // eslint-disable-next-line vue/no-unused-components
    CustomerName,
    // eslint-disable-next-line vue/no-unused-components
    ShipmentProgressStatus,
    // eslint-disable-next-line vue/no-unused-components
    TransferredStatus,
    // eslint-disable-next-line vue/no-unused-components
    ContractStatusScheduled,
    // eslint-disable-next-line vue/no-unused-components
    DebtorContractAction,
	// eslint-disable-next-line vue/no-unused-components
	TrackStatus,
	// eslint-disable-next-line vue/no-unused-components
	TrackDeviceMark,
  },
  props: {
    rowData: Array,
    columnDefs: { type: Array },
    rowSelection: {type: String, default: "multiple"},
    suppressRowClickSelection: {type: Boolean, default: true},
    frameworkComponents: Object,
    detailCellRenderer: String,
    detailCellRendererParams: Object,
    groupDefaultExpanded: { type: Number, default: 0 },
    masterDetail: Boolean,
    detailRowHeight: { type: [String, Number], default: 300 },
    minHeight: { type: String, default: "300px" },
    height: { type: [String, "default", "dynamic"], default: "default" },
    maxHeight: { type: String, default: "" },
    width: { type: String, default: "100%" },
    withTitle: { type: Boolean, default: false },
	  withButtonGroup: { type: Boolean, default: false },
    withTabs: { type: Boolean, default: false },
    withDescription: { type: Boolean, default: false },
	  withShortDescription: { type: Boolean, default: false },
	  withHintBox: { type: Boolean, default: false },
    withHeader: { type: Boolean, default: false },
    withBorder: { type: Boolean, default: true },
    noTableHeaderClass: { type: Boolean, default: false },
    loadingWarningText: { type: String, default: null },
    excelStyles: Array,
  },
  data() {
    return {
      dynamicHeight: this.minHeight,
      gridColumnApi: null,
      gridApi: null,
      modules: AllModules,
      icons: {
        sortUnSort: '<i class="fa fa-sort"/>',
        sortAscending: '<i class="fa fa-sort-up"/>',
        sortDescending: '<i class="fa fa-sort-down"/>'
      },
      autoGroupColumnDef: {},
      gridOptions: {
        defaultColDef: {
          sortable: false,
          //suppressSizeToFit: true,
          suppressMenu: true,
          menuTabs: [],
			headerComponentFramework: "CustomHeader",
			headerGroupComponentFramework: "CustomGroupHeader"
        },
        unSortIcon: true,
        rowClass: "ag_row",
        localeText: {
          loadingOoo: this.loadingWarningText || this.$t("common.table.loading.msg"),
          noRowsToShow: this.$t("common.table.empty.msg")
        },
        // rowModelType: "serverSide", //无限滚动
        // cacheBlockSize: 50, //fetch 100 rows per at a time
        // maxBlocksInCache: 10,
        animateRows: true,
        rowHeight: 40,
        headerHeight: 40,
        onGridReady: params => {
          // 获取gridApi
          this.gridApi = params.api;
          this.gridColumnApi = params.columnApi;
          this.$emit("getGridApi", this.gridApi);
	      this.syncSorting(true);
          // 调整表格列宽大小自适应
          this.isTofit();
          // this.autoSizeAll();
          // if (this.realL) {
          //   this.realL.forEach(item => {
          //     if (item.sortable) {
          //       params.api.getFilterInstance(item.field);
          //     }
          //   });
          // }
        },
		onGridSizeChanged: params => {
			this.isTofit();
		},
        onRowSelected: params => {
          this.$emit("row-select", params);
        }
      }
    };
  },
	beforeMount() {
    this.styleColumns();
    this.setupHeight();
  },
  mounted() {
    window.onresize = () => {
      this.isTofit();
    };
  },
  methods: {
    setupHeight() {
      if (this.height === "default") {
		  let offset = 175
			  + (this.withTitle ? 40 : 0)
			  + (this.withButtonGroup ? 55 : 0)
			  + (this.withTabs ? 55 : 0)
			  + (this.withDescription ? 65 : 0)
			  + (this.withShortDescription ? 45 : 0)
			  + (this.withHintBox ? 50 : 0)
			  + (this.withHeader ? 50 : 0);

        this.height = "calc(100vh - " + offset + "px)";
      }
    },
    onSortChanged() {
      this.syncSorting(false)
    },
	syncSorting(initial) {
		const gridSorting = this.gridApi.getSortModel();
		const hasSorting = gridSorting.length > 0;

		if (initial && !hasSorting) {
			return; // No sync necessary
		}

		let backendSorting = gridSorting.map(entry => {
			return {
				columnName: this.gridColumnApi.getColumn(entry.colId).colDef.field,
				direction: entry.sort.toUpperCase()
			};
		});
		this.$emit("sortChanged", backendSorting);
	},
    isTofit() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    onFirstDataRendered(params) {
      /*      params.api.forEachNode(function(node) {
        node.setExpanded();
      });*/
    },
    getScoll() {
      // document.addEventListener("DOMContentLoaded", function() {
      //   var gridDiv = document.querySelector("#myGrid");
      //   new agGrid.Grid(gridDiv, gridOptions);
      //   agGrid
      //     .simpleHttpRequest({
      //       url:
      //         "https://raw.githubusercontent.com/ag-grid/ag-grid/master/packages/ag-grid-docs/src/olympicWinners.json"
      //     })
      //     .then(function(data) {
      //       // add id to data
      //       var idSequence = 0;
      //       data.forEach(function(item) {
      //         item.id = idSequence++;
      //       });
      //       var server = new FakeServer(data);
      //       var datasource = new ServerSideDatasource(server);
      //       gridOptions.api.setServerSideDatasource(datasource);
      //     });
      // });
    },
    processCellForClipboard(params) {
      let valueFormatter = params.column.colDef.valueFormatter;

      if (!valueFormatter) {
        return params.value;
      }

      let valueFormatterParams = {
        ...params,
        colDef: params.column.colDef,
        data: params.node.data
      };

      return valueFormatter(valueFormatterParams);
    },
    autoSizeAll() {
      const allColumnIds = [];
      this.gridColumnApi.getAllColumns().forEach(function(column) {
        allColumnIds.push(column.colId);
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds);
    },
    styleColumns() {
      let hasSingleHeaderRow = this.columnDefs.every(def => !def.children);

      this.columnDefs.forEach((def, index) => {
        this.styleColumn(def, def, index, index, hasSingleHeaderRow);
      });

    },
    styleColumn(columnDef, groupColumnDef, groupIndex, childIndex, hasSingleHeaderRow) {
      if (!columnDef.headerClass) {
        columnDef.headerClass = "";
      }

      if (groupColumnDef.headerClass && groupColumnDef.headerClass.includes("bg_special")) {
        columnDef.headerClass += (groupIndex % 2 === 0 || hasSingleHeaderRow) ? " bg_special_dark" : " bg_special_light";
      } else {
        columnDef.headerClass += this.noTableHeaderClass ? '' : (groupIndex % 2 === 0 || hasSingleHeaderRow) ? " bg_dark" : " bg_light";
      }

      if (childIndex === 0) {
        columnDef.headerClass += " first_in_group";

        if (groupIndex === 0) {
          columnDef.headerClass += " first_child";
        }
      }

      if (columnDef.children) {
        columnDef.children.forEach((child, childIndex) => {
          this.styleColumn(child, groupColumnDef, groupIndex, childIndex, hasSingleHeaderRow);
        });
      }
    },
	  showAllColumns(show) {
		  this.gridColumnApi.getAllDisplayedColumnGroups().forEach((value) => {
			  if (value.isExpandable()) {
				  this.gridColumnApi.setColumnGroupOpened(value.getOriginalColumnGroup(), show);
			  }
		  });
	  },
  },
  computed: {
    ...mapGetters({ upTableData: "upTableData", upTabType: "upTabType" }),
    tableStyle() {
      let width = this.width ? "width: " + this.width + ";" : "";
      let minHeight = this.minHeight
        ? "min-height: " + this.minHeight + ";"
        : "";
      let height =
        this.height === "dynamic"
          ? "height:" + this.dynamicHeight + ";"
          : "height: " + this.height + ";";
      let maxHeight = this.maxHeight
        ? "max-height: " + this.maxHeight + ";"
        : "";

      return width + minHeight + height + maxHeight;
    },
    realRowData() {
      let r = this.rowData;
      if (r && r.length > 0) {
        r = r.map(item => {
          if (item.currency) {
            item.amountName = this.formatMoney(item.amount) + item.currency;
          }
          if (item.amount) {
            item.amountFormat = this.formatMoney(item.amount);
          }

          if (item.outstanding) {
            item.outstandingName =
              this.formatMoney(item.outstanding) +
              "(" +
              item.outstandingPer +
              ")";
          }
          return item;
        });

        if (this.height === "dynamic") {
          let adjustmentForPaddingMarginAndBorder = 4;
          this.dynamicHeight = this.gridOptions.headerHeight
                             + adjustmentForPaddingMarginAndBorder
                             + r.length * this.gridOptions.rowHeight
                             + "px";
        }
      }

      return r;
    },
    realL() {
      let c = this.columnDefs;
      if (c) {
        c = c.map(item => {
          item.menuTabs = [];
          item.suppressMovable = true;
          item.comparator = this.dateComparator;
          if (item.children && item.children.length > 0) {
            item.children = item.children.map(cItem => {
              cItem.menuTabs = [];
              cItem.comparator = this.dateComparator;
              return cItem;
            });
          }
          return item;
        });
      }
      return c;
    }
  },
  watch: {
    rowData() {
      this.isTofit();
    },
    columnDefs() {
    	if (this.gridApi) {
		    this.gridApi.setColumnDefs(this.columnDefs);
		    this.styleColumns();
		    this.isTofit();
		}
    },
  }
};
</script>
